import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TAgentInvitation } from '../types/agent.type';
import { z } from 'zod';

/**
 *
 */
export const ResendInviteAgentValidationSchema = z.object({
  invitationId: z.string({ message: 'Invitation ID is required' }).min(1),
});
export type TResendInviteAgentValidation = z.infer<typeof ResendInviteAgentValidationSchema>;
export type TResendInviteAgentPayload = TResendInviteAgentValidation;
export type TResendInviteAgentResponse = ApiResponse<TAgentInvitation>;

export const resendInviteAgent = (payload: TResendInviteAgentPayload): Promise<TResendInviteAgentResponse> => {
  const url = `/invitation/resend/${payload.invitationId}`;

  return axiosInstance.post(url);
};

type UseResendInviteAgentOptions = {
  mutationConfig?: TypedMutationConfig<typeof resendInviteAgent, AxiosErrorCustom>;
};

export const useResendInviteAgent = ({ mutationConfig }: UseResendInviteAgentOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation<TResendInviteAgentResponse, AxiosErrorCustom, TResendInviteAgentPayload>({
    mutationFn: resendInviteAgent,
    ...restConfig,
  });
};
